import { useCustomReportFilterDefaultValues } from "shared/components/pillar-table/filters/hooks/useCustomReportFilterDefaultValues";
import PillarTableFilterCheckbox from "shared/components/pillar-table/filters/PillarTableFilterCheckbox";
import PillarTableFilterDatePicker from "shared/components/pillar-table/filters/PillarTableFilterDatePicker";
import PillarTableFilterHidden from "shared/components/pillar-table/filters/PillarTableFilterHidden";
import PillarTableFiltersCustomReport from "shared/components/pillar-table/filters/PillarTableFiltersCustomReport";
import PillarTableFilterSelectMenu from "shared/components/pillar-table/filters/PillarTableFilterSelectMenu";
import PillarTableFilterSingleDate from "shared/components/pillar-table/filters/PillarTableFilterSingleDate";
import PillarTableFilterTextInput from "shared/components/pillar-table/filters/PillarTableFilterTextInput";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

export interface PillarTableFiltersProps {
  children?: React.ReactNode;
  className?: string;
}

export type PillarTableFilterComponentType =
  React.JSXElementConstructor<any> & {
    defaultValue?: any;
  };

const PillarTableFilters = ({
  children,
  className,
}: PillarTableFiltersProps) => {
  const { setFilters } = usePillarTableContext();

  const { hasCustomReportFilters } = useCustomReportFilterDefaultValues();

  if (hasCustomReportFilters) {
    return <PillarTableFiltersCustomReport />;
  }
  return (
    <div className={`h-full ${className ?? ""}`}>
      <div className="flex justify-start w-full mb-1 mr-1 items-end gap-1 flex-wrap">
        {children}

        {children && (
          <button
            data-testid="clear-filters-button"
            type="button"
            className="p-1 h-4.75 border rounded border-neutral-mid-200 text-filter-label mr-0.25 whitespace-nowrap"
            onClick={() => setFilters({})}
          >
            Clear Filters
          </button>
        )}
      </div>
    </div>
  );
};
export default PillarTableFilters;

PillarTableFilters.Checkbox = PillarTableFilterCheckbox;
PillarTableFilters.SingleDate = PillarTableFilterSingleDate;
PillarTableFilters.DatePicker = PillarTableFilterDatePicker;
PillarTableFilters.TextInput = PillarTableFilterTextInput;
PillarTableFilters.Hidden = PillarTableFilterHidden;
PillarTableFilters.SelectMenu = PillarTableFilterSelectMenu;
